import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChangePasswordService } from 'src/services/changePasswordService';
import { AuthenticationService } from '../_services/authentication.service';
import { ToasterService } from '../_services/toaster.service';
import { Title } from '@angular/platform-browser';
import { NiceScrollService } from '../_services/nice-scroll.service';
declare var jquery: any;
declare var $: any;
@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  constructor(private router: Router,
     private changePasswordService: ChangePasswordService,
     private authenticationService: AuthenticationService,
     private tostrService: ToasterService,
     private title: Title,
     private niceScroll: NiceScrollService
     ) {
   // niceScroll.scrollToTop();
     }
  UserFullName: string;
  ProfileImageUrl: string;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  ngOnInit() {
 this.SetUserName();
 this.title.setTitle(this.UserFullName + ' | Change Password | pakmatti.com');
  }

  Submit(changePassword: any) {
 $('body').addClass('loading').loader('show', { overlay: true });
 this.changePasswordService.PostService('ChangePassword', changePassword.form.value).subscribe(response => {
   if (response.IsSuccess) {
  this.tostrService.Info(response.Message);
   } else {
  this.tostrService.Error(response.Message);
   }
   $('body').removeClass('loading').loader('hide');
 });
  }

  Logout(): void {
// this.authenticationService.logout();
  }


  public SetUserName() {
 const applicationUser = JSON.parse(localStorage.getItem('currentUser'));
 this.UserFullName = applicationUser.FirstName + ' ' + applicationUser.LastName;
 this.ProfileImageUrl = applicationUser.ImageUrl == null ? '/assets/images/default-avatar.png' : applicationUser.ImageUrl;
  }
}
